import { BookingObject } from 'src/types';

import { ParkingState } from './types';

export const emptyBookingObjects = new Map<string, BookingObject>();

export const initialState: ParkingState = {
  loading: false,
  locationLoading: false,
  bookingObjects: emptyBookingObjects,
  date: undefined,
  time: '09:00—18:00',
  currentRequestId: undefined,
  parkingBookingSheetIsOpened: false,
};
